"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var makeFormControlPhoneNumberStyling = function (_a) {
    var _b, _c;
    var isAnswered = _a.isAnswered, isAutoFilledActive = _a.isAutoFilledActive, isSafari = _a.isSafari, hasError = _a.hasError, theme = _a.theme;
    return (0, react_1.css)({
        width: '100%',
        '& .MuiInputLabel-shrink': {
            marginLeft: 87,
        },
        '& .MuiInputBase-root input': {
            paddingLeft: '1.2rem !important',
            borderLeft: 'none',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            backgroundColor: 'transparent',
        },
        '& .MuiInputBase-root': {
            boxShadow: 'none',
        },
        '& .phone-input-container': __assign(__assign(__assign(__assign(__assign({ width: '100%', display: 'flex', alignItems: 'stretch', position: 'relative', border: "1px solid ".concat(theme.mvf.palette.component.answerUnselectedColor), borderRadius: '4px', overflow: 'hidden', backgroundColor: "".concat(theme.mvf.palette.background.answerBackgroundColor, " !important") }, (isAutoFilledActive && {
            backgroundColor: "".concat(isSafari ? 'rgb(250, 255, 189)' : 'rgb(232, 240, 254)', " !important"),
        })), { boxShadow: theme.mvf.boxShadow.timid }), (isAnswered &&
            !hasError && {
            borderColor: theme.mvf.palette.component.answerSelectedColor,
        })), { '@media (hover: hover)': {
                '&:hover': {
                    borderColor: hasError
                        ? theme.mvf.palette.status.error
                        : theme.mvf.palette.component.answerSelectedColor,
                    '& .country-selector': {
                        borderRightColor: hasError
                            ? theme.mvf.palette.status.error
                            : theme.mvf.palette.component.answerSelectedColor,
                    },
                },
            }, '&:has(input:focus)': {
                borderColor: hasError
                    ? theme.mvf.palette.status.error
                    : theme.mvf.palette.component.answerSelectedColor,
                boxShadow: theme.mvf.boxShadow.fierce,
                '& .country-selector': {
                    borderRightColor: hasError
                        ? theme.mvf.palette.status.error
                        : theme.mvf.palette.component.answerSelectedColor,
                },
            } }), (hasError && {
            borderColor: theme.mvf.palette.status.error,
        })),
        '& .MuiInputBase-root.MuiInputBase-formControl': {
            width: '100%',
            flex: 1,
            border: 'none',
            backgroundColor: 'transparent',
            boxShadow: 'none !important',
            '& .MuiInputBase-input': {
                border: 'none',
                borderRadius: 0,
                backgroundColor: 'transparent',
            },
        },
        '&:has(.MuiInputLabel-root) .phone-input-container .MuiInputBase-root input': {
            paddingTop: '2.2rem !important',
        },
        '& .country-selector': __assign(__assign({ paddingLeft: theme.mvf.spacing.smedium, paddingRight: theme.mvf.spacing.smedium, borderRight: "1px solid ".concat(theme.mvf.palette.component.answerUnselectedColor), backgroundColor: 'transparent' }, (isAnswered &&
            !hasError && {
            borderRightColor: theme.mvf.palette.component.answerSelectedColor,
        })), (hasError && {
            borderRightColor: theme.mvf.palette.status.error,
        })),
        '& .Mui-error .phone-input-container': {
            borderColor: theme.mvf.palette.status.error,
            '& .country-selector': {
                borderRightColor: theme.mvf.palette.status.error,
            },
        },
        '& .Mui-focused .phone-input-container .country-selector': {
            borderColor: theme.mvf.palette.component.answerSelectedColor,
            '& .country-selector': {
                borderRightColor: theme.mvf.palette.component.answerSelectedColor,
            },
        },
        '& .MuiSelect-root': {
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
        },
        // Theme styling for the country picker dropdown
        '& .MuiPaper-root': {
            backgroundColor: theme.mvf.palette.background.answerBackgroundColor,
            border: "1px solid ".concat(theme.mvf.palette.component.answerUnselectedColor),
            boxShadow: theme.mvf.boxShadow.timid,
            '& .MuiMenuItem-root': (_b = {
                    color: theme.mvf.palette.text.primaryTextColor,
                    fontSize: theme.mvf.fontSize.mini
                },
                _b[theme.breakpoints.up('mobileMedium')] = {
                    fontSize: theme.mvf.fontSize.small,
                },
                _b['&:hover'] = {
                    backgroundColor: (0, material_1.lighten)(theme.mvf.palette.component.answerSelectedColor, theme.mvf.filters.lighten.extreme),
                },
                _b['&.Mui-selected'] = {
                    backgroundColor: (0, material_1.lighten)(theme.mvf.palette.component.answerSelectedColor, 0.9),
                    color: theme.mvf.palette.component.answerSelectedColor,
                    fontWeight: theme.mvf.typography.weight.thick,
                },
                _b),
        },
        // Search input styling within dropdown
        '& .country-search-input': {
            '& .MuiInputBase-input': (_c = {
                    fontSize: theme.mvf.fontSize.mini
                },
                _c[theme.breakpoints.up('mobileMedium')] = {
                    fontSize: theme.mvf.fontSize.small,
                },
                _c.color = theme.mvf.palette.text.primaryTextColor,
                _c['&::placeholder'] = {
                    color: theme.mvf.palette.text.secondaryTextColor,
                    fontWeight: theme.mvf.typography.weight.medium,
                },
                _c),
        },
        // Autofill styling support for browsers that support :has() selector
        '@supports (selector(:has(*)))': {
            '& .phone-input-container:has(input:-webkit-autofill) .country-selector': {
                backgroundColor: "".concat(isSafari ? 'rgb(250, 255, 189)' : 'rgb(232, 240, 254)', " !important"),
            },
        },
    });
};
exports.default = makeFormControlPhoneNumberStyling;
//# sourceMappingURL=makeFormControlPhoneNumberStyling.js.map